import Head from "next/head";
import LoadingAnimation from "./LoadingAnimation";

const LoadingPage = ({
  title: title = "Moongate",
  children,
  size: size = 48,
}: {
  title?: string;
  children?: any;
  size?: number;
}) => {
  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <div className="flex flex-row content-center justify-center h-screen w-screen">
        <div className="flex flex-col justify-center items-center fixed h-full w-full">
          <LoadingAnimation size={size} />
          {children}
        </div>
      </div>
    </>
  );
};

export default LoadingPage;
